import {Component, OnInit} from '@angular/core';
import {TUI_PROMPT, TuiPaginationModule, TuiPromptData} from '@taiga-ui/kit'
import {TuiInputModule} from '@taiga-ui/kit';
import {
  TuiAlertModule,
  TuiAlertService,
  TuiButtonModule,
  TuiDialogService,
  TuiDropdownModule,
  TuiRootModule,
  TuiTextfieldControllerModule, TuiSvgModule, TuiLoaderModule
} from "@taiga-ui/core";
import {TuiTableModule} from '@taiga-ui/addon-table';
import {TuiDataListModule} from '@taiga-ui/core';
import {TuiDataListWrapperModule, TuiSelectModule, TuiToggleModule} from '@taiga-ui/kit';
import {ReactiveFormsModule, FormsModule, FormBuilder} from '@angular/forms';
import {UserService} from "../../core/services/user.service";
import {Router} from "@angular/router";
import {PageSize} from "../../core/dto/page.size";
import {Pagination} from "../../core/dto/pagination";
import {CommonModule} from "@angular/common";
import {TuiActiveZoneModule, TuiObscuredModule, TuiValueChangesModule} from "@taiga-ui/cdk";
import {EncryptionService} from "../../core/services/encryption.service";
import {AuthService} from "../../modules/auth/services/auth.service";

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [TuiPaginationModule,
    TuiInputModule, TuiTableModule,
    TuiTextfieldControllerModule,
    TuiDataListWrapperModule,
    TuiDataListModule,
    TuiSelectModule, TuiButtonModule,
    ReactiveFormsModule, FormsModule,
    CommonModule, TuiValueChangesModule,
    TuiRootModule,
    TuiDropdownModule,
    TuiActiveZoneModule, TuiObscuredModule,
    TuiAlertModule,
    TuiToggleModule,
    TuiSvgModule, TuiLoaderModule,
  ],
  providers: [
    UserService,
    EncryptionService,
    AuthService,
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent implements OnInit {
  statusitems = [
    'Active',
    'Inactive',
  ];
  open = false;
  pageSize = new PageSize();
  sort = -1;
  searchText: any;
  userStatus = 'Active';
  tempStatus = true;
  statusMsg = false;
  userData: any[] = [];
  openStates: boolean[] = [];
  isLoading = false;
  showSearch = false;
  user:any;
  tempSearchText = ''


  constructor(
    private router: Router,
    private userService: UserService,
    private AuthService: AuthService,
    private readonly dialogs: TuiDialogService,
    private readonly alerts: TuiAlertService) {
  }

  ngOnInit(): void {
    this.getPaginatedUsers();
    this.user = this.AuthService.getLoggedInUser();
  }

  getPaginatedUsers(): void {

    const payload = Object.assign({}, new Pagination(this.pageSize), {
      filters: {
        sortFilter: this.sort,
        searchValue: this.searchText,
        status: this.tempStatus,
      },
    });
    this.isLoading = true;
    this.userService.getPagedUsers(payload).then((res) => {
      this.userData = res.data;
      this.isLoading = false;
      this.userData.forEach(() => this.openStates.push(false));
      this.pageSize.length = res.totalPages;
    })

  }

  toggleSort() : void {
    if (this.sort === -1) {
      this.sort = 1;
    } else {
      this.sort = -1
    }
    this.getPaginatedUsers();
  }

  statusChange(): void {
    this.tempStatus = !this.tempStatus;
  }

  resetStatus(): void {
    this.tempStatus = true;
    this.userStatus = 'Active';
    this.statusMsg = false;
    this.searchText = '';
    this.tempSearchText = '';

    this.getPaginatedUsers()
  }

  showText(): string {
    let text = '';
    if (this.statusMsg && this.tempSearchText) {
    text += `Showing Results for "${this.tempSearchText}"`;
    }
    return text;
  }
  

  search(): void {
this.statusMsg = true;
this.tempSearchText = this.searchText;
    this.getPaginatedUsers()
  }

  cancelSearch(event: Event): void {
    if (!event) {
      this.searchText = null;
      this.getPaginatedUsers();
    }
  }

  toggle(): void {
    this.showSearch = !this.showSearch;
  }

  goToPage(event: any): void {
    this.pageSize.pageIndex = event + 1;
    this.getPaginatedUsers();
  }

  navigateToAdd(): void {
    this.router.navigate(['admin/users/add-edit'])
  }

  navigateToUpdate(data: any): void {
    if (!(data.role === 'SUPER_ADMIN')) {
      this.router.navigate([`admin/users/add-edit/${data._id}`])
    }
  }

  toggleDropdown(index: number): void {
    // Toggle the dropdown state for the specified row index
    this.openStates[index] = !this.openStates[index];
  }

  onClick(index: number): void {
    this.openStates.fill(false);
    this.toggleDropdown(index);
  }

  onActiveZone(event: any): void {
    // Handle active zone change event
    if (!event) {
      this.openStates.fill(false);
    }
  }

  onObscured(event: any): void {
  }

  onDelete(id: any, email: any): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to delete ${email}`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          this.userService.softDeleteUser(id).then(() => {
            this.openStates.fill(false);
            this.alerts
              .open('<p style="color: green">User Deleted Successfully</p>')
              .subscribe();
            this.ngOnInit();
          }).catch(() => {
            this.alerts
              .open('<p style="color: red">Deleting User Unsuccessful</p>',{status: 'error'})
              .subscribe();
          });
        }
      });
  }


  onStatusChange(user: any): void {

    let content = '';
    let yesLabel = '';
    let noLabel = '';

    if (user.isActive) {
      content = `Are you sure you want to deactivate User : ${user.email}`;
      yesLabel = 'Deactivate';
      noLabel = 'Cancel';
    } else {
      content = `Are you sure you want to activate User : ${user.email}`;
      yesLabel = 'Activate';
      noLabel = 'Cancel';
    }

    const data: TuiPromptData = {
      content: content,
      yes: yesLabel,
      no: noLabel,
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          user.isActive = !user.isActive

          this.userService.updateUser(
            {
              _id: user._id,
              ...user
            }
          ).then(() => {
            this.openStates.fill(false);
            this.alerts
              .open('<p style="color: green">User Status Changed Successfully</p>')
              .subscribe();
            this.ngOnInit();
          }).catch(() => {
            this.alerts
              .open('<p style="color: red">User Status Change UnSuccessful</p>',{status: 'error'})
              .subscribe();
          })
        }
      });
  }


  checkValid(role:any): boolean{
    if (role === 'SUPER_ADMIN'){
      return false;
    } else if ( role === 'ADMIN' && (this.user.role === 'ADMIN' || this.user.role === 'USER')) {
      return false;
    } else if (role === 'USER') {
      return false
    }
    return true;
  }

  onSendNewPassword(id: any, email: any): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to change the password for ${email}`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          this.userService.resetUserPasswordEmail(id).then(() => {
            this.openStates.fill(false);
            this.alerts
              .open('<p style="color: green">New user credentials sent successfully</p>')
              .subscribe();
            this.ngOnInit();
          }).catch(() => {
            this.alerts
              .open('<p style="color: red">Error Sending New Password Credentials</p>',{status: 'error'})
              .subscribe();
          });
        } else {

        }
      });
  }
}
